import { render, staticRenderFns } from "./DeliverableEditor.vue?vue&type=template&id=975763d2&"
import script from "./DeliverableEditor.vue?vue&type=script&lang=js&"
export * from "./DeliverableEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports